// Module configuration form builder
// Generates forms dynamically based on module type schemas

class ModuleConfigForm {
  constructor(moduleType, schema, initialConfig = {}) {
    this.moduleType = moduleType;
    this.schema = schema;
    this.config = { ...initialConfig };
    this.formElement = null;
  }

  render() {
    const form = document.createElement("form");
    form.style.cssText = "padding: 20px;";

    // Render each field from schema
    this.schema.fields.forEach((field) => {
      const fieldContainer = this.renderField(field);
      form.appendChild(fieldContainer);
    });

    // Add buttons
    const buttonContainer = document.createElement("div");
    buttonContainer.style.cssText =
      "display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px;";

    const cancelBtn = document.createElement("button");
    cancelBtn.type = "button";
    cancelBtn.textContent = "Cancel";
    cancelBtn.className = "btn btn-secondary";
    cancelBtn.onclick = () => {
      if (this.onCancel) this.onCancel();
    };

    const submitBtn = document.createElement("button");
    submitBtn.type = "submit";
    submitBtn.textContent = "Insert Module";
    submitBtn.className = "btn btn-primary";

    buttonContainer.appendChild(cancelBtn);
    buttonContainer.appendChild(submitBtn);
    form.appendChild(buttonContainer);

    form.onsubmit = (e) => {
      e.preventDefault();
      this.collectFormData();
      if (this.onSubmit) {
        this.onSubmit(this.config);
      }
    };

    this.formElement = form;
    return form;
  }

  renderField(field) {
    const container = document.createElement("div");
    container.style.cssText = "margin-bottom: 15px;";

    const label = document.createElement("label");
    label.textContent = field.label || field.name;
    label.style.cssText =
      "display: block; margin-bottom: 5px; font-weight: 500;";
    if (field.required) {
      label.textContent += " *";
    }

    let input;
    if (field.type === "text" || field.type === "string") {
      input = document.createElement("input");
      input.type = "text";
      input.value = this.config[field.name] || "";
      input.placeholder = field.placeholder || "";
    } else if (field.type === "textarea") {
      input = document.createElement("textarea");
      input.value = this.config[field.name] || "";
      input.rows = field.rows || 3;
      input.placeholder = field.placeholder || "";
    } else if (field.type === "number") {
      input = document.createElement("input");
      input.type = "number";
      input.value = this.config[field.name] || "";
    } else if (field.type === "date") {
      input = document.createElement("input");
      input.type = "date";
      input.value = this.config[field.name] || "";
    } else if (field.type === "url") {
      input = document.createElement("input");
      input.type = "url";
      input.value = this.config[field.name] || "";
      input.placeholder = field.placeholder || "https://...";
    } else if (field.type === "array") {
      // Simple array input (comma-separated for now)
      input = document.createElement("input");
      input.type = "text";
      const arrayValue = this.config[field.name];
      input.value = Array.isArray(arrayValue) ? arrayValue.join(", ") : "";
      input.placeholder = field.placeholder || "Comma-separated values";
    } else {
      // Default to text
      input = document.createElement("input");
      input.type = "text";
      input.value = this.config[field.name] || "";
    }

    input.name = field.name;
    input.id = `module-config-${field.name}`;
    input.style.cssText =
      "width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px; box-sizing: border-box;";
    if (field.required) {
      input.required = true;
    }

    container.appendChild(label);
    container.appendChild(input);

    if (field.help) {
      const help = document.createElement("small");
      help.textContent = field.help;
      help.style.cssText = "display: block; margin-top: 4px; color: #666;";
      container.appendChild(help);
    }

    return container;
  }

  collectFormData() {
    const formData = new FormData(this.formElement);
    this.schema.fields.forEach((field) => {
      const value = formData.get(field.name);
      if (field.type === "array") {
        // Parse comma-separated values
        this.config[field.name] = value
          ? value
              .split(",")
              .map((v) => v.trim())
              .filter((v) => v)
          : [];
      } else if (field.type === "number") {
        this.config[field.name] = value ? Number(value) : null;
      } else {
        this.config[field.name] = value || null;
      }
    });
  }
}

export default ModuleConfigForm;
